import * as GlobalFilters from "components/Shared/GlobalFilter/constants"

const filterSwitchingSelectorsConfig = {
	[GlobalFilters.VENDORS]: {
		isMulti: true,
		allOption: true,
	},
	[GlobalFilters.DEPARTMENTS]: {
		isMulti: false,
		allOption: false,
		isClearable: true,
		initialValue: false,
	},
	[GlobalFilters.CATEGORIES]: {
		isMulti: false,
		allOption: false,
		initialValue: false,
	},
	[GlobalFilters.SUBCATEGORIES]: {
		isMulti: false,
		allOption: false,
	},
	[GlobalFilters.FINELINE]: {
		isMulti: false,
		allOption: false,
	},
}
export default filterSwitchingSelectorsConfig
